export const MEMBERSHIPS_RESET_STATE = 'MEMBERSHIPS_RESET_STATE';
export const MEMBERSHIPS_CURRENT_ITEM = 'MEMBERSHIPS_CURRENT_ITEM';
 
export const MEMBERSHIPS_REQUEST_LOADING = 'MEMBERSHIPS_REQUEST_LOADING';
export const MEMBERSHIPS_REQUEST_SUCCESS = 'MEMBERSHIPS_REQUEST_SUCCESS';
export const MEMBERSHIPS_REQUEST_FAILED = 'MEMBERSHIPS_REQUEST_FAILED';
 
export const MEMBERSHIPS_CURRENT_ACTION = 'MEMBERSHIPS_CURRENT_ACTION';
export const MEMBERSHIPS_RESET_ACTION = 'MEMBERSHIPS_RESET_ACTION';